import { Link } from 'react-router-dom'
import { LeftButton, PrevPageIcon } from './navigation.styled'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'
import {
  FairtradeLeftButton,
  FairtradeNavLabel,
  FairtradePrevPageIcon,
} from 'src/templates/fairtrade/navigation/fairtrade-nav-buttons.styled'

type PreviousPageProps = {
  to: string
  state?: object
  absolute?: boolean
  isImpactPage?: boolean
  isTopDivider?: boolean
  topOffset?: number
  label?: string
  variant?: 'default' | JOURNEY_PAGE_TEMPLATE_ID
  backgroundColor?: string
  textColor?: string
}

export const PreviousPage = ({
  to,
  state,
  absolute,
  isImpactPage,
  isTopDivider,
  topOffset,
  label,
  variant = 'default',
  backgroundColor,
  textColor,
}: PreviousPageProps) => {
  const isFairtradeVariant = variant === JOURNEY_PAGE_TEMPLATE_ID.FAIRTRADE

  return (
    <Link to={to} state={state ? state : null}>
      {isFairtradeVariant ? (
        <FairtradeLeftButton
          id="previous-page-component__components-navigation__fairtradeleftbutton__l40"
          size="medium"
          aria-label="Previous Page"
          absolute={absolute}
          isImpactPage={isImpactPage}
          isTopDivider={isTopDivider}
          topOffset={topOffset}
          backgroundColor={backgroundColor}
          textColor={textColor}
        >
          <FairtradePrevPageIcon id="previous-page-component__components-navigation__fairtradeprevpageicon__l50" />
          {label && (
            <FairtradeNavLabel id="previous-page-component__components-navigation__fairtradenavlabel__l52">
              {label}
            </FairtradeNavLabel>
          )}
        </FairtradeLeftButton>
      ) : (
        <LeftButton
          id="previous-page-component__components-navigation__leftbutton__l21"
          size="medium"
          aria-label="Previous Page"
          absolute={absolute}
          isImpactPage={isImpactPage}
          isTopDivider={isTopDivider}
          topOffset={topOffset}
        >
          <PrevPageIcon id="previous-page-component__components-navigation__prevpageicon__l28" />
        </LeftButton>
      )}
    </Link>
  )
}
